/**
 * NOS-125: Dashboard CRUD for media_topics with video counts.
 * NOS-262: instantiation of the org-taxonomy factory.
 */
import type { Database } from "@/types/database"
import { generateSlug } from "@/lib/slugUtils"
import { makeOrgTaxonomyHook } from "./useOrgTaxonomy"

type MediaTopic = Database["public"]["Tables"]["media_topics"]["Row"]

export interface MediaTopicWithCount extends MediaTopic {
  video_count: number
}

export interface MediaTopicInput {
  name: string
  slug?: string
}

export const useMediaTopics = makeOrgTaxonomyHook<MediaTopicWithCount, MediaTopicInput>({
  table: "media_topics",
  orderBy: "name",
  duplicateMessage: "A topic with this slug already exists.",
  count: { via: "junction", table: "media_video_topics", fk: "topic_id" },
  deleteGuard: {
    table: "media_video_topics",
    fk: "topic_id",
    selectColumn: "video_id",
    message: "Remove this topic from all videos before deleting.",
  },
  prepare: (v) => ({
    name: v.name.trim(),
    slug: v.slug?.trim() || generateSlug(v.name),
  }),
})
